import { render, staticRenderFns } from "./instSaveDemand.vue?vue&type=template&id=0858cca8&scoped=true"
import script from "./instSaveDemand.vue?vue&type=script&lang=js"
export * from "./instSaveDemand.vue?vue&type=script&lang=js"
import style0 from "./instSaveDemand.vue?vue&type=style&index=0&id=0858cca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0858cca8",
  null
  
)

export default component.exports